import { defineMessages } from 'react-intl';
export default defineMessages({
    add: {
        id: 'common.add',
        defaultMessage: 'Add'
    },
    altitude: {
        id: 'common.altitude',
        defaultMessage: 'Altitude'
    },
    analysis: {
        id: 'common.analysis',
        defaultMessage: 'Analysis'
    },
    average: {
        id: 'common.average',
        defaultMessage: 'Average'
    },
    back: {
        id: 'common.back',
        defaultMessage: 'Back'
    },
    backToHome: {
        id: 'common.backToHome',
        defaultMessage: 'Back to Home'
    },
    cancel: {
        id: 'common.cancel',
        defaultMessage: 'Cancel'
    },
    cannotBeEmpty: {
        id: 'common.cannotBeEmpty',
        defaultMessage: 'This field cannot be empty.'
    },
    close: {
        id: 'common.close',
        defaultMessage: 'Close'
    },
    dailyForecast: {
        id: 'common.dailyForecast',
        defaultMessage: 'Daily forecast'
    },
    default: {
        id: 'common.default',
        defaultMessage: 'Default'
    },
    delete: {
        id: 'common.delete',
        defaultMessage: 'Delete'
    },
    details: {
        id: 'common.details',
        defaultMessage: 'Details'
    },
    edit: {
        id: 'common.edit',
        defaultMessage: 'Edit'
    },
    exitFullscreen: {
        id: 'common.exitFullscreen',
        defaultMessage: 'Exit fullscreen'
    },
    forecast: {
        id: 'common.forecast',
        defaultMessage: 'Forecast'
    },
    frequency: {
        id: 'common.frequency',
        defaultMessage: 'Frequency'
    },
    full: {
        id: 'common.full',
        defaultMessage: 'Full'
    },
    fullscreen: {
        id: 'common.fullscreen',
        defaultMessage: 'Fullscreen'
    },
    help: {
        id: 'common.help',
        defaultMessage: 'Help'
    },
    hidden: {
        id: 'common.hidden',
        defaultMessage: 'Hidden'
    },
    high: {
        id: 'common.high',
        defaultMessage: 'High'
    },
    iDontKnowYet: {
        id: 'common.iDontKnowYet',
        defaultMessage: "I don't know yet"
    },
    indoor: {
        id: 'common.indoor',
        defaultMessage: 'Indoor'
    },
    labelValue: {
        id: 'common.labelValue',
        defaultMessage: '{label}: {value}'
    },
    lastUpdate: {
        id: 'common.lastUpdate',
        defaultMessage: 'Last update'
    },
    low: {
        id: 'common.low',
        defaultMessage: 'Low'
    },
    maximum: {
        id: 'common.maximum',
        defaultMessage: 'Maximum'
    },
    medium: {
        id: 'common.medium',
        defaultMessage: 'Medium'
    },
    minimum: {
        id: 'common.minimum',
        defaultMessage: 'Minimum'
    },
    more: {
        id: 'common.more',
        defaultMessage: 'More'
    },
    moreInformation: {
        id: 'common.moreInformation',
        defaultMessage: 'More information'
    },
    next: {
        id: 'common.next',
        defaultMessage: 'Next'
    },
    no: {
        id: 'common.no',
        defaultMessage: 'No'
    },
    noAccountNeeded: {
        id: 'common.noAccountNeeded',
        defaultMessage: 'No account needed'
    },
    noItemsAvailable: {
        id: 'common.noItemsAvailable',
        defaultMessage: 'No items available'
    },
    notNow: {
        id: 'common.notNow',
        defaultMessage: 'Not Now'
    },
    openSettings: {
        id: 'common.openSettings',
        defaultMessage: 'Open Settings'
    },
    outdoor: {
        id: 'common.outdoor',
        defaultMessage: 'Outdoor'
    },
    pageNotFound: {
        id: 'common.pageNotFound',
        defaultMessage: 'Page Not Found'
    },
    pageNotFoundDescription: {
        id: 'common.pageNotFoundDescription',
        defaultMessage: "The page you're looking for doesn't exist or has been moved."
    },
    now: {
        id: 'common.now',
        defaultMessage: 'Now'
    },
    rain: {
        id: 'common.rain',
        defaultMessage: 'Rain'
    },
    share: {
        id: 'common.share',
        defaultMessage: 'Share'
    },
    /*
     * Snackbar over the "Share your weather" dialog when the card could not be
     * captured or the system share sheet failed to open (#292).
     */
    shareImageFailed: {
        id: 'common.shareImageFailed',
        defaultMessage: "Couldn't share the image"
    },
    shareYourWeather: {
        id: 'common.shareYourWeather',
        defaultMessage: 'Share your weather'
    },
    skip: {
        id: 'common.skip',
        defaultMessage: 'Skip'
    },
    start: {
        id: 'common.start',
        defaultMessage: 'Start'
    },
    unknown: {
        id: 'common.unknown',
        defaultMessage: 'Unknown'
    },
    validEmail: {
        id: 'common.validEmail',
        defaultMessage: 'A valid email address is required.'
    },
    validate: {
        id: 'common.validate',
        defaultMessage: 'Confirm'
    },
    very_low: {
        id: 'common.very_low',
        defaultMessage: 'Very low'
    },
    weatherObservations: {
        id: 'common.weatherObservations',
        defaultMessage: 'Weather observations'
    },
    welcome: {
        id: 'common.welcome',
        defaultMessage: 'Welcome to SmartMixin!'
    },
    wind: {
        id: 'common.wind',
        defaultMessage: 'Wind'
    },
    yes: {
        id: 'common.yes',
        defaultMessage: 'Yes'
    },
    zoomImage: {
        id: 'common.zoomImage',
        defaultMessage: 'Zoom image'
    }
});
